import { YN_TYPE } from "types/enumType";

export default interface Equipment {
  itemCode: string;
  mdmCode: string;
  code: string;
  id: number;
  name: string;
  deptId: number;
  deptName: string;
  section: string;
  activate: YN_TYPE;
  leftPos: number;
  topPos: number;
  width: number;
  height: number;
  image: string;
}

export class EquipmentInfo {
  itemCode: string;

  mdmCode: string;

  eqCd: string;

  code: string;

  id: number;

  name: string;

  deptId: number;

  activate: YN_TYPE;

  constructor(id: number) {
    this.itemCode = '';
    this.mdmCode = '';
    this.eqCd = '';
    this.code = '';
    this.id = id;
    this.name = '';
    this.deptId = 1;
    this.activate = YN_TYPE.Y;
  }
}